const mediaItems = [
  {
    title: '《封神第三部》终极预告',
    desc: '乌尔善导演奇幻史诗巨制最终章，众神之战一触即发。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20movie%20scene%20with%20ancient%20warriors%20and%20mythical%20creatures%20in%20battle%2C%20dramatic%20golden%20and%20crimson%20sky%2C%20cinematic%20lighting%2C%20grand%20scale%20composition%2C%20dark%20atmospheric%20mood%2C%20no%20text&width=800&height=450&seq=media-01&orientation=landscape',
    duration: '02:35',
    tag: '预告片',
    views: '892万',
  },
  {
    title: '《流浪地球3》幕后特辑',
    desc: '郭帆导演分享科幻制作的幕后故事，从概念到银幕的震撼旅程。',
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20science%20fiction%20film%20production%20with%20futuristic%20set%20and%20equipment%2C%20cinematic%20lighting%20with%20cool%20blue%20and%20warm%20orange%20contrast%2C%20industrial%20aesthetic%2C%20dark%20atmospheric%20mood%2C%20no%20text&width=800&height=450&seq=media-02&orientation=landscape',
    duration: '08:12',
    tag: '幕后花絮',
    views: '456万',
  },
  {
    title: '《鱿鱼游戏》第三季先导片',
    desc: '全球期待的韩剧最终季首发影像，全新游戏与规则揭晓在即。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20intense%20scene%20with%20geometric%20colorful%20staircase%20and%20dramatic%20red%20lighting%2C%20suspenseful%20cinematic%20composition%2C%20dark%20and%20mysterious%20atmosphere%2C%20no%20text%2C%20thriller%20mood&width=800&height=450&seq=media-03&orientation=landscape',
    duration: '01:48',
    tag: '先导片',
    views: '1,230万',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1024px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-accent-500/10 text-accent-400 text-xs font-medium mb-3 whitespace-nowrap">
            <i className="ri-play-circle-line text-xs"></i>
            精彩看点
          </span>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-100 mb-2">
            精彩预告
          </h2>
          <p className="text-foreground-500 text-sm">热门影视预告片与幕后花絮</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-300/40 hover:border-background-400/60 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-300/30">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/90 group-hover:bg-primary-500 group-hover:scale-110 transition-all">
                    <i className="ri-play-fill text-foreground-50 text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-1 rounded-md bg-background-900/80 text-foreground-50 text-xs font-medium whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-1 rounded-md bg-accent-500/90 text-foreground-50 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-200 mb-1 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-xs mb-2 line-clamp-2">{item.desc}</p>
                <div className="flex items-center gap-1 text-foreground-500 text-xs">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}